import CloseIcon from '@mui/icons-material/Close';
import { IconButton, IconButtonProps, SxProps, Theme } from '@mui/material';
import React from 'react';

export interface DialogCloseButtonProps extends IconButtonProps {
  onClose?: (ev: React.MouseEvent) => void;
  sx?: SxProps<Theme>;
}

export function DialogCloseButton({ onClose, sx, ...rest }: DialogCloseButtonProps) {
  const handleClose = (ev: React.MouseEvent) => {
    onClose?.(ev);
  };

  return (
    <IconButton
      aria-label="close"
      onClick={handleClose}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: (theme: Theme) => theme.palette.grey[500],
        ...sx,
      }}
      {...rest}
    >
      <CloseIcon />
    </IconButton>
  );
}
